const headerContainer = document.querySelector('.wp-block-hs-blocks-ui-component-header-bar-container');

const initAnchorscrollingFix = () => {

    const scrollToAnchor = (anchor,behavior = 'smooth') =>{

        if(anchor === ''){
            window.scrollTo({
                top:0,
                behavior: behavior
            })
            return;
        }
        
        const cords = headerContainer.getBoundingClientRect();
        const headerBottom = cords.x + cords.height;
        const anchorTargetElement = document.querySelector(anchor); 

        window.scrollTo({
            //top: anchorTargetElement.offsetTop - headerBottom,
            top: anchorTargetElement.getBoundingClientRect().top+window.scrollY - headerBottom,
            behavior: behavior
        })

    }

    // on load
    history.scrollRestoration = "auto";
    window.addEventListener('load',()=>{

        let anchor = window.location.hash;

        if(anchor){
            setTimeout(()=>{
                scrollToAnchor(anchor)
            },100)
           
        }
    })

    // on scroll
    window.addEventListener('click',(e)=>{
        let anchor = e.target.closest("a[href^='#']");

        if(anchor){
            e.preventDefault();
            scrollToAnchor(anchor.getAttribute("href"))
            history.pushState(null, "", anchor.getAttribute("href")); // Update URL without jumping
        }
    })

    window.addEventListener('hashchange',(e)=>{
        let anchor = window.location.hash;
        scrollToAnchor(anchor)

    })

}

const initHeaderContainer = () => {

    const toggleVisibiltyOnScroll = headerContainer.dataset.toggleVisibiltyOnScroll === "true";

    if(!toggleVisibiltyOnScroll){
        return;
    }

    const lookUpAR = {

        headerHeight: false,
        clientX: 0,
        clientY: 0,
        lastScrollposY: false,
        lastScrollVisibiltyState: true,
    }

    const treshHold_scrollY = 100;
    const treshHold_clientY = 200;

    const setHeaderContainerVisibilityState = (state = true) =>{
    
        if(state){
            headerContainer.classList.remove('hidden');
            headerContainer.style.top = `0px`;
        }else{
            headerContainer.classList.add('hidden')
            headerContainer.style.top = `-${lookUpAR.headerHeight}px`;
        }
    }

    const update = () => {

        
        lookUpAR.headerHeight = headerContainer.getBoundingClientRect().height;

        if (lookUpAR.lastScrollposY === false || lookUpAR.lastScrollposY === window.scrollY) {
            lookUpAR.lastScrollposY = window.scrollY;
            return;
        }

        if (lookUpAR.lastScrollposY > window.scrollY || window.scrollY <= 0) {
            lookUpAR.lastScrollVisibiltyState = true;
        } else {
            lookUpAR.lastScrollVisibiltyState = false;
        }

        lookUpAR.lastScrollposY = window.scrollY;

        //apply new state
        setHeaderContainerVisibilityState(lookUpAR.lastScrollVisibiltyState);

    }

    hs_core.addTask(update);

}

// wip
const initHeaderContainer2 = () => {

    const lookUpAR = {
        headerHeight: false,
        headerBottomPos: false,
        isLocked: false,
        isLockedTill: Date.now(),
        lastScrollYPos: false,
        lockDurationInMs: 2000,
        toggleVisibiltyOnScroll: headerContainer.dataset.toggleVisibiltyOnScroll === "true"
    }


    // on scrolling
    window.addEventListener('scroll',(e)=>{

        return;
        const toggleVisibiltyOnScroll = headerContainer.dataset.toggleVisibiltyOnScroll === "true";

        if(!toggleVisibiltyOnScroll || lookUpAR.lastScrollYPos === window.scrollY){
            return;
        }

        if(lookUpAR.lastScrollYPos < window.scrollY){
            setHeaderContainerVisibilityState(false)
        }else{
            setHeaderContainerVisibilityState(true)
        }

        lookUpAR.lastScrollYPos = window.scrollY;

    })

    // fix anchor scrolling
    history.scrollRestoration = "manual";

    window.addEventListener('load',()=>{
        console.log('page loaded')
        let anchor = window.location.hash;

        console.log('page loaded')
        if(anchor){
            setTimeout(()=>{
                scrollToAnchor(anchor,'smooth',true)
            },100)
           
        }
    })


    // internal functions
    const setHeaderContainerVisibilityState = (state = true) =>{
    
        if(state){
            headerContainer.classList.remove('hidden');
            headerContainer.style.top = `0px`;
        }else{
            headerContainer.classList.add('hidden')
            headerContainer.style.top = `-${lookUpAR.headerHeight}px`;
        }
    }

    const scrollToAnchor = (anchorStr,behavior,lockHeader=false) => {

        let scrollYTarget = 0;

        if(anchorStr !== ''){
            scrollYTarget = document.querySelector(anchorStr).offsetTop - lookUpAR.headerBottomPos;
        };

        if(lockHeader){
            lookUpAR.isLocked = true;
            lookUpAR.isLockedTill = Date.now()+lookUpAR.lockDurationInMs;
        }

        window.scrollTo({
            top: scrollYTarget,
            behavior: behavior
        });

    }

    // main update function
    const update = ()=>{

        const headerCords = headerContainer.getBoundingClientRect();
        lookUpAR.headerBottomPos = headerCords.x+headerCords.height;
        lookUpAR.headerHeight = headerCords.height;

        if(Date.now() < lookUpAR.isLockedTill){
            console.log('header is locked')
            lookUpAR.lastScrollYPos = window.scrollY;
            return;
        }

        if(!lookUpAR.toggleVisibiltyOnScroll || lookUpAR.lastScrollYPos === window.scrollY){
            return;
        }

        if(lookUpAR.lastScrollYPos < window.scrollY){
            setHeaderContainerVisibilityState(false)
        }else{
            setHeaderContainerVisibilityState(true)
        }

        lookUpAR.lastScrollYPos = window.scrollY;

    }

    hs_core.addTask(update);

}

initHeaderContainer();
initAnchorscrollingFix();

//initHeaderContainer2();